/*
* Copyright (C) 2019 Pengkun.Yao Co., Ltd. All rights reserved.
*/
/* eslint-disable */
export default {
  isWeixin() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true
    } else {
      return false
    }
  },
  isIOS() {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/(iPhone|iPod|iPad|Mac);?/i)) {
      return true
    } else {
      return false
    }
  },
  isAndroid() {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/android/i)) {
      return true
    } else {
      return false
    }
  },
  isIpad() {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/iPad|iPod|Mac/i)) {
      return true
    } else {
      return false
    }
  },
  isOnlineSchool(){
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/jzh/i)) {
      return true
    } else {
      return false
    }
  },
  GetQueryValue(queryName) {
    var query = decodeURI(window.location.search.substring(1));
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == queryName) { return pair[1]; }
    }
    return null;
  }
}
